module.exports = __webpack_public_path__ + "img/helicopter_black.44c4dbae.png";